export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["user"] = "ECDUser";
    LocalStorageKeys["hasViewedJulProgressReport"] = "HasViewedJulProgressReport";
    LocalStorageKeys["hasViewedDecProgressReport"] = "HasViewedDecProgressReport";
    LocalStorageKeys["acquisitionTracking"] = "acquisitionTracking";
})(LocalStorageKeys || (LocalStorageKeys = {}));
//# sourceMappingURL=local-storage-keys.js.map